export const RANGE_BUILDERS: Record<
  string,
  (today: Date) => [startDate: Date, endDate: Date]
> = {
  today: (today) => [today, today],
  'last-7-days': (today) => {
    const newStartDate = new Date()
    newStartDate.setUTCDate(newStartDate.getUTCDate() - 7)
    return [newStartDate, today]
  },
  'last-30-days': (today) => {
    const newStartDate = new Date()
    newStartDate.setUTCDate(today.getUTCDate() - 29)
    return [newStartDate, today]
  },
}

export function dateObjectToPickerValue(date: Date) {
  return {
    day: date.getUTCDate(),
    month: date.getUTCMonth(),
    year: date.getUTCFullYear(),
  }
}

export function isoStringToPickerValue(isoDate: string) {
  return dateObjectToPickerValue(new Date(isoDate))
}

export function pickerValueToIsoString({
  day,
  month,
  year,
  hours,
  minutes,
  seconds,
}: {
  day: number
  month: number
  year: number
  hours: number
  minutes: number
  seconds: number
}) {
  const parsedDate = new Date()

  parsedDate.setUTCDate(day)
  parsedDate.setUTCMonth(month)
  parsedDate.setUTCFullYear(year)
  parsedDate.setUTCHours(hours, minutes, seconds, 0)

  return parsedDate.toISOString()
}

export function handleHide(
  hideFunction: () => void,
  shouldCallFunction?: boolean
) {
  return () => {
    if (!shouldCallFunction) return
    hideFunction()
  }
}
